// The "what's in the area" page. Could make this page a lot cooler and maybe even split it into
// multiple pages eventually. A page for the grotto, a page with the top 10 things, etc.
// Even if I don't make new pages this page definitely needs more than a weak bullet list

// IMPORTS FROM MUI
import { List, ListItem, Typography } from "@mui/material"

// THE ACTUAL COMPONENT
export const WhatsInTheArea = () => {
    return (
        <div className='page'>
            
            <Typography variant='h4'>
                We're the closest campground to:
            </Typography>

            <List sx={{
                    listStyleType: 'disc',
                    pl: 2,
                    '& .MuiListItem-root': {
                    display: 'list-item',
                }}}>

                <ListItem>
                    Tobermory downtown (restaurants, stores, tennis courts) (2.5 km: a 7 minute bike ride or a 27 minute walk)
                </ListItem>
                <ListItem>
                    The Chi-cheemaun car ferry (2.9 km: an 11 minute bike ride or a 39 minute walk)
                </ListItem>
                <ListItem>
                    The head of the Bruce Trail (2.6 km: a 10 minute bike ride or a 35 minute walk)
                </ListItem>
                <ListItem>
                    Fathom Five National Marine Park (3.0 km: an 11 minute bike ride or a 41 minute walk)
                </ListItem>
                <ListItem>
                    Glass bottom boat cruises (2.2 km: an 8 minute bike ride or a 30 minute walk)
                </ListItem>
            </List>
        </div>
    )
}